import { render, staticRenderFns } from "./additionalservice.vue?vue&type=template&id=49a3fefa&scoped=true&"
import script from "./additionalservice.vue?vue&type=script&lang=js&"
export * from "./additionalservice.vue?vue&type=script&lang=js&"
import style0 from "./additionalservice.vue?vue&type=style&index=0&id=49a3fefa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a3fefa",
  null
  
)

export default component.exports